import React from 'react';
import PropTypes from 'prop-types';
import formatWeight from '../../../utils/formatWeight';

const WeightCell = ({
    weightCarriedLbs,
    horseHeadGear,
    firstTimeHeadgear,
}) => (
    <span>
        {formatWeight(weightCarriedLbs)}
        {horseHeadGear && (
            <span>
                &nbsp;{horseHeadGear}
                {firstTimeHeadgear && (<sup>1</sup>)}
            </span>
        )}
    </span>
);

WeightCell.propTypes = {
    weightCarriedLbs: PropTypes.number,
    horseHeadGear: PropTypes.string,
    firstTimeHeadgear: PropTypes.bool,
};

export default WeightCell;



// WEBPACK FOOTER //
// ./src/js/horse/form/formTable/WeightCell.jsx